import { getCookie, chatSessionCookieKey, setState, getState } from './storageManager';
import Notification from './notification';
import injectTranscriptButton from './transcript';
import showEndChatButton from './survey';
import radioButton from './radioButton';
// import { doc } from 'prettier';

let isWindowActive = true;
let isUserConnected = false;
let isBotConnected = false;
let channelConnected = [];
let chatLob = '';
let scrnPosition;
/**
 * TODO: I'm sorry; Hopefully a Genesys fix will resolve need for timeout here
 */
function toggleUserTyping(shouldEnable, timeout) {
  if (shouldEnable) {
    // Enable client ability to type in Chat
    setTimeout(() => {
      const msgInputTextArea = document.getElementsByClassName('cx-message-input')[0];
      if (msgInputTextArea) {
        msgInputTextArea.disabled = false;
        msgInputTextArea.placeholder = 'Type your message here';
        document
          .querySelector(`[data-message="ChatInputSend"] > svg`)
          .setAttribute('aria-label', 'Send');
      }
      msgInputTextArea.focus();
    }, timeout);
  } else {
    // Disable client ability to type in chat
    setTimeout(() => {
      const msgInputTextArea = document.getElementsByClassName('cx-message-input')[0];
      if (msgInputTextArea) {
        msgInputTextArea.disabled = true;
        msgInputTextArea.placeholder = '';
      }
    }, timeout);
  }
}

function registerChatChannelEvents(userId) {
  window.onfocus = () => {
    isWindowActive = true;
  };
  window.onblur = () => {
    isWindowActive = false;
  };
  const CXBus = window._genesys.widgets.bus;
  let isChatRestoring = false;

  function onConnected(details) {
    isBotConnected = details && details.data.message.from.type === 'Bot';
    channelConnected.push(details.data.message.from.type);

    isUserConnected = true;
    if (!isBotConnected || isChatRestoring) {
      toggleUserTyping(true, 1000);
    }
    if (
      !isChatRestoring &&
      window.channelsConfig.chat &&
      window.channelsConfig.chat.enableTranscript &&
      !isBotConnected
    ) {
      injectTranscriptButton(userId);

      setState({
        chatSessionId: getCookie(chatSessionCookieKey),
        transcriptsEnabled: window.channelsConfig.chat.enableTranscript,
      });
    }
    if (window.channelsConfig.popupMode) {
      showEndChatButton();
    }
  }

  const buttonLineBreak = text => {
    const phoneRegEx = /\d{1}-\d{3}-\d{3}-\d{4}/gm;
    let buttonText = text;
    if (buttonText.search(phoneRegEx) > -1) {
      const index = buttonText.search(phoneRegEx);
      buttonText = `${buttonText.substring(0, index - 1)}<br>${buttonText.substring(index)}`;
    }
    return buttonText;
  };

  CXBus.subscribe('WebChatService.ended', () => {
    if (isUserConnected) {
      const { chatSurveyLink } = getState();
      let chatSurveyLob = '';
      if (chatSurveyLink) {
        let channel;
        if (channelConnected.includes('Agent') && channelConnected.includes('Bot')) {
          channel = 'chatbotlivechat';
          chatSurveyLob = `&LOB=${chatLob}`;
        } else if (channelConnected.includes('Agent')) {
          channel = 'livechat';
        } else {
          channel = 'chatbot';
        }
        channelConnected = [];
        window._genesys.widgets.bus.command('WebChat.injectMessage', {
          type: 'html',
          custom: true,
          text: `<div class = 'cx-message-group'>
                  <div class = 'cx-rich-media'>
                  <div class = 'cx-structure cx-generic cx-var-2'>
                  <h2 class = 'cx-markdown-survey' style-group='3'>
                  <p>Thank you for contacting Travelers. We were happy to assist you today. Please rate your experience by clicking the button below.</p>
                  </h2>
                  <a id='endChatSurveyButton' class='cx-button' href=${chatSurveyLink}&channel=${channel}${chatSurveyLob} target='_blank'>Survey</a>
                  </div>
                  </div>
                  </div>`,
        });
      }
      chatLob = '';
      isUserConnected = false;
    }
  });

  CXBus.subscribe('WebChatService.botDisconnected', () => {
    isUserConnected = false;
  });

  CXBus.subscribe('WebChat.opened', () => {
    if (window.matchMedia('(max-width: 660px)').matches) {
      scrnPosition = document.scrollingElement.scrollTop || document.documentElement.scrollTop;
      scrnPosition = Math.abs(scrnPosition);
      console.log('Chat Open Screen Scrolled Position ::', scrnPosition);
      // window.scrollTo(0, 0);
    }

    document
      .querySelector(`[data-icon="minimize"] > svg`)
      .setAttribute('aria-label', 'minimize this');

    if (!window.matchMedia('(max-width: 660px)').matches) {
      document
        .querySelector(`[data-icon="minimize"]`)
        .setAttribute('onmousedown', "document.querySelector(`[data-icon='minimize']`).click();");
    }

    document.querySelector(`[data-icon="close"] > svg`).setAttribute('aria-label', 'close this');

    document
      .querySelector(`[data-icon="close"]`)
      .setAttribute('onmousedown', "document.querySelector(`[data-icon='close']`).click();");

    document.querySelector(`[aria-label="Genesys"] > svg`).setAttribute('aria-label', 'genesys');
    window.dispatchEvent(
      new CustomEvent('chat.opened', {
        detail: {
          subject: 'chat',
          subTopic: 'chatwindow',
        },
      }),
    );
    const { transcriptsEnabled } = getState();
    if (isChatRestoring && transcriptsEnabled && !isBotConnected) {
      injectTranscriptButton(userId);
    }
    isChatRestoring = false;
    const chatFormStartButton = document.getElementsByClassName(
      'cx-submit cx-btn cx-btn-primary i18n',
    )[0];
    const form = document.getElementsByClassName('cx-form-wrapper')[0];
    if (chatFormStartButton && form) {
      const formFields = document.getElementsByClassName('cx-form-inputs')[0]?.children[0]
        ?.children;
      let foundFirstNonhiddenElement = false;
      let firstNonhiddenFormInput;
      formFields.forEach(formField => {
        const isFieldDisplayed = formField.style.display !== 'none';
        if (!foundFirstNonhiddenElement && isFieldDisplayed) {
          foundFirstNonhiddenElement = true;
          firstNonhiddenFormInput = formField.children[0]?.children[0];
        }
        if (firstNonhiddenFormInput && foundFirstNonhiddenElement) {
          firstNonhiddenFormInput.focus();
        } else {
          chatFormStartButton.focus();
        }
      });
    }
  });

  CXBus.subscribe('WebChat.started', () => {
    toggleUserTyping(false, 0);
  });

  CXBus.subscribe('WebChat.completed', () => {
    setState({
      transcriptsEnabled: null,
      transcriptRequestSucceeded: null,
    });
    isChatRestoring = false;
    window.dispatchEvent(
      new CustomEvent('chat.completed', {
        detail: {
          subject: 'chat',
          subTopic: 'chatend',
          value: getCookie(chatSessionCookieKey),
        },
      }),
    );
  });

  // No longer a requirement for this tag
  CXBus.subscribe('WebChat.cancelled', () => {
    window.dispatchEvent(
      new CustomEvent('chat.cancelled', {
        detail: {
          subject: 'chat',
          subTopic: 'chatcancel',
          value: getCookie(chatSessionCookieKey), // TODO: no session here?
        },
      }),
    );
  });

  CXBus.subscribe('WebChat.closed', () => {
    if (window.matchMedia('(max-width: 660px)').matches) {
      console.log('Chat Closed Screen Scrolled Position ::', scrnPosition);
      window.scrollTo(0, 0);
    }

    setState({ chatSessionId: null });
    window.dispatchEvent(
      new CustomEvent('chat.closed', {
        detail: {
          subject: 'chat',
          subTopic: 'chatclose',
        },
      }),
    );
  });

  CXBus.subscribe('WebChat.messageAdded', message => {
    // check the bowser tab is active and highlight if not
    if (!isWindowActive) {
      Notification.notifyTab();
    }

    const spanForAccessibility = document.createElement('SPAN');
    spanForAccessibility.textContent = '(Opens in same tab)';
    spanForAccessibility.style.position = 'absolute';
    spanForAccessibility.style.width = '1px';
    spanForAccessibility.style.clip = 'rect(0 0 0 0)';
    spanForAccessibility.style.overflow = 'hidden';
    spanForAccessibility.style.whiteSpace = 'nowrap';

    if (
      message.data.html &&
      message.data.html[0] &&
      message.data.html[0].getElementsByClassName('cx-message-text').length > 0 &&
      message.data.html[0].getElementsByClassName('cx-message-text')[0]
    ) {
      if (
        message.data.html[0].getElementsByClassName('cx-message-text')[0].getElementsByTagName('A')
          .length > 0 &&
        message.data.html[0]
          .getElementsByClassName('cx-message-text')[0]
          .getElementsByTagName('A')[0]
      ) {
        const newMessageWithAnchor = message.data.html[0]
          .getElementsByClassName('cx-message-text')[0]
          .getElementsByTagName('A')[0];
        const targetIsSelf = newMessageWithAnchor.getAttribute('target') === '_self';
        if (targetIsSelf) {
          newMessageWithAnchor.insertAdjacentElement('beforeend', spanForAccessibility);
        } else {
          spanForAccessibility.textContent = '(Opens in new tab)';
          newMessageWithAnchor.insertAdjacentElement('beforeend', spanForAccessibility);
        }
      }
    }
  });

  CXBus.subscribe('WebChatService.agentConnected', onConnected);
  CXBus.subscribe('WebChatService.started', webServiceStartedEvent => {
    const sessionId = webServiceStartedEvent.data.sessionID;
    window.dispatchEvent(
      new CustomEvent('chat.started', {
        detail: {
          subject: 'chat',
          subTopic: 'chatstart',
          value: sessionId,
        },
      }),
    );
    const { overrides, surveyLink } = window.channelsConfig.chat;
    if (surveyLink.includes('userId')) {
      setState({ chatSurveyLink: `${surveyLink}&session_id=${sessionId}` });
    } else {
      setState({ chatSurveyLink: `${surveyLink}?session_id=${sessionId}` });
    }
    if (overrides) {
      overrides.forEach(override => {
        override.paths.forEach(() => {
          if (override.config.surveyLink) {
            // TODO: this should be set using setState, but not until a future major update, as it would break compatibility with older versions
            setState({ claimSurveyLink: `${override.config.surveyLink}&session_id=${sessionId}` });
          }
        });
      });
    }
  });

  CXBus.subscribe('WebChatService.botConnected', onConnected);

  CXBus.subscribe('WebChatService.ended', () => {
    if (window.channelsConfig.popupMode) {
      const endChatButton = document.querySelector('.cx-end-chat-button');
      endChatButton.style.display = 'none';
    }
    setTimeout(() => {
      const surveyBtn = document.getElementById('endChatSurveyButton');
      if (surveyBtn) {
        surveyBtn.focus();
      }
    }, 50);
  });

  CXBus.subscribe('WebChatService.restored', () => {
    // Restrict text input until agent connected
    toggleUserTyping(false, 1000);
    isChatRestoring = true;
  });

  // added this listener to detect click on the deep link inside bot's reply
  CXBus.subscribe('RichMedia.created', event => {
    const buttons = event.data.instance && event.data.instance.getElementsByClassName('cx-button');
    const deepLinks = event.data.instance && event.data.instance.getElementsByTagName('a');
    deepLinks.forEach(deepLink => {
      deepLink.addEventListener('click', () => {
        const widgetWidth = document.getElementsByClassName('cx-body')[0].clientWidth;
        const deviceWidth = window.screen.width;
        // minimize widget if it is in mobile mode
        if (widgetWidth === deviceWidth) {
          CXBus.command('WebChat.minimize');
        }
        window.dispatchEvent(
          new CustomEvent('RichMedia.click', {
            detail: { subject: 'SSE' },
          }),
        );
      });
    });

    const radioList = event.data.instance.getElementsByClassName(
      'cx-component cx-list-item cx-cta-link cx-clickable',
    );
    if (radioList.length > 1) {
      radioButton.startRadio(radioList);
    }

    if (buttons && buttons.length > 0) {
      buttons[0].innerHTML = buttonLineBreak(buttons[0].innerText);
    }
    // scroll window to the bottom when rich-media components are added
    const chatContainer = document.getElementsByClassName('cx-transcript')[0];
    if (chatContainer) {
      chatContainer.scrollTo(0, chatContainer.scrollHeight);
    }
  });

  // move textback message hidden into selected option to resolve masking issue
  CXBus.subscribe('WebChatService.ready', () => {
    CXBus.command('WebChatService.registerPreProcessor', {
      preprocessor(message) {
        let content =
          message &&
          message.eventAttributes &&
          message.eventAttributes['structured-content'] &&
          message.eventAttributes['structured-content']['genesys-chat'].content;
        if (content) {
          content = JSON.parse(content);
          const buttonTypes = ['button', 'list-item'];
          if (
            content.content &&
            content.content[0] &&
            content.content[0].components &&
            buttonTypes.includes(content.content[0].components[0].type)
          ) {
            message.utcTime = null;
          }
        }

        // eslint-disable-next-line no-console
        console.log('message', message);
        window.cxMessage = message;
        if (
          (message.from.nickname === 'Virtual Assistant' ||
            message.from.nickname === 'Travelers') &&
          message.type === 'Message'
        ) {
          toggleUserTyping(true, 1000);
        }
        // checks every incoming message, not just ones from type Client
        if (
          message &&
          message.eventAttributes &&
          message.eventAttributes['structured-content'] &&
          message.eventAttributes['structured-content']['genesys-chat']
        ) {
          // it returns Claim or PI
          const messageContent = JSON.parse(
            message.eventAttributes['structured-content']['genesys-chat'].content,
          );
          const firstQuickReply = messageContent.content[0];
          if (
            firstQuickReply &&
            firstQuickReply.text &&
            firstQuickReply.text.toLowerCase().indexOf('yes, connect') !== -1
          ) {
            if (firstQuickReply.handoff_lob && firstQuickReply.handoff_lob !== '') {
              chatLob = firstQuickReply.handoff_lob;
            }
          }
        }
        // Check if the message is from customer and some additional checking.
        if (message.from.type === 'Client' && typeof message.eventAttributes !== 'undefined') {
          const response = message.text;
          if (response && response.indexOf('*') !== -1) {
            return message;
          }
        }
        return message;
      },
    });
  });

  CXBus.subscribe('RichMedia.click', event => {
    const actions = event.data && event.data.actions;
    const text =
      event &&
      event.data &&
      event.data.originalJSON &&
      event.data.originalJSON.text &&
      event.data.originalJSON.text.toLowerCase();
    let subject = '';
    if (text && text.indexOf('yes, connect') !== -1) {
      subject = 'LIVECHAT';
    } else if (actions.url && actions.url.indexOf('tel') !== -1) {
      subject = 'PHONE';
    }
    if (subject) {
      window.dispatchEvent(
        new CustomEvent('RichMedia.click', {
          detail: { subject },
        }),
      );
    }
  });
}

function registerCobrowseChannelEvents(cobrowseAPI) {
  if (cobrowseAPI) {
    // triggers when customer starts cobrowse and session id is generated
    cobrowseAPI.onSessionStarted.add(details => {
      const subTopic = 'cust_connect';
      const subject = details.widgetOrigin === 'WebChat' ? 'chat_cobrowse' : 'phone_cobrowse';
      setState({ cobrowseSubject: subject, cobrowseId: details.token });
      window.dispatchEvent(
        new CustomEvent('cobrowse.started', {
          detail: {
            subject,
            subTopic,
            value: details.token,
          },
        }),
      );
    });

    // triggers when ISR joins the cobrowse session
    cobrowseAPI.onAgentJoined.add((agent, session) => {
      const { cobrowseSubject } = getState();
      window.dispatchEvent(
        new CustomEvent('cobrowse.agentJoined', {
          detail: {
            subject: cobrowseSubject,
            subTopic: 'isr_connect',
            value: session.token,
          },
        }),
      );
    });

    // triggers when cobrowse session is disconnected
    cobrowseAPI.onSessionEnded.add(details => {
      const subTopic = details.reason === 'self' ? 'disconnect_cust' : 'disconnect';
      const { cobrowseSubject, cobrowseId } = getState();
      window.dispatchEvent(
        new CustomEvent('cobrowse.ended', {
          detail: {
            subject: cobrowseSubject,
            subTopic,
            value: cobrowseId,
          },
        }),
      );
    });
  }
}

function dispatchChannelsListeners() {
  window.dispatchEvent(
    new CustomEvent('channels.events', {
      detail: [
        { eventName: 'chat.opened', tagType: 'meta' },
        { eventName: 'chat.started', tagType: 'meta' },
        { eventName: 'chat.completed', tagType: 'meta' },
        { eventName: 'chat.cancelled', tagType: 'meta' },
        { eventName: 'chat.closed', tagType: 'meta' },
        { eventName: 'chat.linkClicked', tagType: 'click' },
        { eventName: 'chat.linkInserted', tagType: 'meta' },
        { eventName: 'chat.eligibility', tagType: 'meta' },
        { eventName: 'cobrowse.started', tagType: 'meta' },
        { eventName: 'cobrowse.linkClicked', tagType: 'click' },
        { eventName: 'cobrowse.agentJoined', tagType: 'meta' },
        { eventName: 'cobrowse.ended', tagType: 'meta' },
        { eventName: 'RichMedia.click', tagType: 'click' },
      ],
    }),
  );
}

export { registerCobrowseChannelEvents, registerChatChannelEvents, dispatchChannelsListeners };
